module.exports = __webpack_public_path__ + "img/IMG_2374.5876cb77.jpg";